import Core from './core'
import Page from './page'
import Content from './content'
import Header from './header'
import Button from './button'
import Video from './video'
import table from './table'
import Audio from './audio'

import VantUi from './vant'

const packages = [
  Page,
  Content,
  Header,
  Button,
  Video,
  Audio,
  table
]

const install = (Vue, { router } = {}) => {
  if (install.installed) {
    return
  }

  install.installed = true

  Vue.use(VantUi)
  Vue.use(Core, {
    router
  })

  packages.forEach((lib) => {
    Vue.use(lib)
  })
}

export default {
  install
}
